import type { BoostTimerFragment } from "@workspace/casino_core/queries/BoostNotificationQuery";
import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import Button from "@workspace/casino_pages/legacyLayer/legacyUi/Button";
import claimBoost from "@/actions/Games/claimBoost";

type Props = {
  boost: BoostTimerFragment;
  translations: Record<string, string>;
  onClose: () => void;
};

const isBoostClaimable = (boost: BoostTimerFragment) => {
  const { claimed, isLimitReached, isTimerOver, winAmount } = boost;
  return !claimed && (winAmount ?? 0) > 0 && (isLimitReached || isTimerOver);
};

const ClaimButton: FC<Props> = ({ boost, translations, onClose }) => {
  const handleClick = () => {
    claimBoost(boost.id);
    onClose();
  };
  return (
    <Button
      className="z-10"
      disabled={!isBoostClaimable(boost)}
      onClick={handleClick}
    >
      <Translation id="casino.boosts.claim_now" translations={translations} />
    </Button>
  );
};

export default ClaimButton;
